import { Injectable } from '@angular/core';

import { common_pb, challenge_ng_grpc_pb, challenge_pb } from 'libs/generated-grpc-web';
import { Observable, Subject } from 'rxjs';

export interface IChallengeInviteSuccesEvent {
  inviteResponseCount?: number;
  invitePeopleCount?: number;
  challengeContextHash: string;
}

@Injectable({ providedIn: 'root' })
export class ChallengeInvitesService {
  private _tempChallengeInvites: string[] = [];
  private _onChallengeInviteSuccess: Subject<IChallengeInviteSuccesEvent> = new Subject();

  constructor(private challengesProto: challenge_ng_grpc_pb.Challenge) {}

  storeTempChallengeInvitesPeople(peopleHashes: string[]) {
    this._tempChallengeInvites = peopleHashes;
  }

  consumeTempChalengeInvitesPeople(): string[] {
    const currentInvites = this._tempChallengeInvites;
    // reset
    this._tempChallengeInvites = [];

    return currentInvites;
  }

  async fetchChallengeInvites(challengeContextHash: string): Promise<challenge_pb.ChallengeInvitePerson.AsObject[]> {
    const request = new common_pb.ContentInfoQuery();
    request.setContentContextHash(challengeContextHash);

    const response = await this.challengesProto.getInvitedPeople(request);
    return response.toObject().personList;
  }

  async invitePeopleToChallenge(challengeContextHash: string, peopleHashes: string[]) {
    const request = new challenge_pb.InviteChallengePeople();
    request.setContentContextHash(challengeContextHash);
    request.setInvitedPersonHashList(peopleHashes);

    return await this.challengesProto.invitePeople(request);
  }

  emitChallengeInviteSuccess(ev: IChallengeInviteSuccesEvent) {
    this._onChallengeInviteSuccess.next(ev);
  }
  get onChallengeInviteSuccess(): Observable<IChallengeInviteSuccesEvent> {
    return this._onChallengeInviteSuccess.asObservable();
  }
}
